import { render, staticRenderFns } from "./balanceRecord.vue?vue&type=template&id=9d8565e4&scoped=true"
import script from "./balanceRecord.vue?vue&type=script&lang=js"
export * from "./balanceRecord.vue?vue&type=script&lang=js"
import style0 from "./balanceRecord.vue?vue&type=style&index=0&id=9d8565e4&prod&scoped=true&lang=css"
import style1 from "./balanceRecord.vue?vue&type=style&index=1&id=9d8565e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8565e4",
  null
  
)

export default component.exports